import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  Text,
  Icon,
  IconWithTooltip,
  TextCopyForTooltip,
  TextWithTooltip
} from '../Elements';

import classes from './ContactPerson.module.scss';

const ContactPerson = ({ person, role, email, phone, personClass }) => {
  return (
    <div className={classes.contact}>
      <Text className={cn(classes.person, personClass)} size={4} weight="b">
        <TextWithTooltip
          text={person && person !== '-' && person !== 'NA' ? person : 'NA'}
        />
      </Text>
      {role && role !== '-' && role !== 'NA' && (
        <Text className={classes.role} size={0}>
          <TextWithTooltip text={role} />
        </Text>
      )}
      <div className={classes.icons}>
        {email ? (
          <div className={classes.email}>
            <IconWithTooltip
              text={
                email ? (
                  <div className={classes.tooltip}>
                    <Text className={classes.tooltip_text} size={2}>
                      {email && email !== '-' && email !== 'NA' ? email : 'NA'}
                    </Text>
                    <a href={'mailto:' + email}>
                      <Icon
                        icon="mail"
                        size="12px"
                        className={classes.tooltip_email}
                      />
                    </a>
                  </div>
                ) : (
                  'NA'
                )
              }
              icon="mail"
              color="#9eb6e9"
              size="12px"
            />
          </div>
        ) : null}
        {phone ? (
          <IconWithTooltip
            text={
              phone ? (
                <TextCopyForTooltip
                  text={phone}
                  notification="activity:contactPerson.ALERT"
                />
              ) : (
                'NA'
              )
            }
            icon="phone"
            color="#9eb6e9"
            size="12px"
          />
        ) : null}
      </div>
    </div>
  );
};

ContactPerson.propTypes = {
  phone: PropTypes.string,
  person: PropTypes.string,
  role: PropTypes.string,
  email: PropTypes.string,
  personClass: PropTypes.string
};

export default ContactPerson;
